module.exports = __webpack_public_path__ + "media/contractFinanceLight.504344a5.svg";